export default "__VITE_ASSET__34v$$BOL__"